<template>
  <div>
    <details-modal
      :show="modals.addressType"
      :current-operation="currentOperation"
      @cancel="closeModal"
      @create="createRecord"
      @delete="deleteRecord"
      @update="updateRecord"
    >
      <form>
        <fg-input
          v-model="addressType.addrtypeLibelle"
          type="text"
          label="Nom"
        />
      </form>
      <p class="errorMessageInModal">{{ errorMessage }}</p>
    </details-modal>
    <div class="row">
      <div class="col-md-12">
        <crud-list
          ref="crudList"
          :fetch-data="fetchAddressTypes"
          title="Types d'adresses"
          @create="create"
          @row-clicked="rowClicked"
        >
          <el-table-column label="Nom">
            <div slot-scope="slotScope">
              {{ slotScope.row.addrtypeLibelle }}&nbsp;
            </div>
          </el-table-column>
        </crud-list>
      </div>
    </div>
  </div>
</template>

<script>
import DetailsModal from './Modals/DetailsModal.vue';
import CrudList from './CrudList.vue';

export default {
  components: {
    CrudList,
    DetailsModal,
  },
  data() {
    return {
      modals: {
        addressType: false,
      },
      currentOperation: {},
      addressType: {},
      errorMessage: '',
    };
  },
  methods: {
    rowClicked(row) {
      this.currentOperation = 'edit';
      this.addressType = { ...row };
      this.modals.addressType = true;
    },
    fetchAddressTypes(pageNumber, pageSize, searchText) {
      let url = process.env.VUE_APP_ANNUAIRE_API_URL;
      if (searchText) {
        url += `/addresstypesEntities/search/fulltext?name=${searchText}&page=${pageNumber -
          1}&size=${pageSize}`;
      } else {
        url += `/addresstypesEntities?page=${pageNumber - 1}&size=${pageSize}`;
      }
      return this.$http.get(url).then(response => ({
        records: response.data._embedded.addresstypesEntities
          ? response.data._embedded.addresstypesEntities
          : [],
        page: response.data.page,
      }));
    },
    deleteRecord() {
      this.errorMessage = 'Deleting...';
      this.$http
        .delete(
          `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/addresstypes/${this.addressType.addrtypeId}`,
        )
        .then(response => {
          this.$refs.crudList.fetch();
          this.errorMessage = '';
          this.modals.addressType = false;
        })
        .catch(error => {
          this.errorMessage =
            'Une erreur est survenue, veuillez réessayer ou contacter le support.';
        });
    },
    updateRecord() {
      this.errorMessage = 'Updating...';
      this.$http
        .patch(
          `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/addresstypes/${this.addressType.addrtypeId}`,
          {
            idaddrtypeId: this.addressType.addrtypeId,
            addrtypeLibelle: this.addressType.addrtypeLibelle,
          },
        )
        .then(response => {
          this.$refs.crudList.fetch();
          this.errorMessage = '';
          this.modals.addressType = false;
        })
        .catch(error => {
          this.errorMessage =
            'Une erreur est survenue, veuillez réessayer ou contacter le support.';
        });
    },
    createRecord() {
      this.$http
        .post(
          `${process.env.VUE_APP_ANNUAIRE_API_URL}/commands/addresstypes/`,
          {
            libelle: this.addressType.addrtypeLibelle,
          },
        )
        .then(response => {
          this.$refs.crudList.fetch();
          this.errorMessage = '';
          this.modals.addressType = false;
        })
        .catch(error => {
          this.errorMessage =
            'Une erreur est survenue, veuillez réessayer ou contacter le support.';
        });
    },
    create() {
      this.addressType = {};
      this.currentOperation = 'create';
      this.modals.addressType = true;
    },
    closeModal() {
      this.modals.addressType = false;
      this.errorMessage = '';
    },
  },
};
</script>

<style scoped></style>
